import { render, staticRenderFns } from "./customCaseList.vue?vue&type=template&id=027d4ae4&scoped=true"
import script from "./customCaseList.vue?vue&type=script&lang=js"
export * from "./customCaseList.vue?vue&type=script&lang=js"
import style0 from "./customCaseList.vue?vue&type=style&index=0&id=027d4ae4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_398719d9ba0fb65ce1cea3b2910bec76/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027d4ae4",
  null
  
)

export default component.exports